import { useState } from "react";
import { CopyIcon } from "@phosphor-icons/react/Copy";
import { CheckIcon } from "@phosphor-icons/react/Check";
import { Icon } from "@freightsimple/ui-core/Icons/Icon";
import type { ApiErrorInfo } from "@freightsimple/api-runtime/errors";

function buildCopyText(info: ApiErrorInfo): string {
  const parts = [info.message];
  if (info.code) parts.unshift(info.code);
  if (info.traceParent) parts.push(`Traceparent: ${info.traceParent}`);
  if (info.details) parts.push(info.details);
  return parts.join("\n");
}

export function ErrorToastContent(info: ApiErrorInfo) {
  const { message, code, details, traceParent } = info;
  const [copied, setCopied] = useState(false);

  function handleCopy() {
    navigator.clipboard.writeText(buildCopyText(info));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div className="space-y-1 text-xs">
      <div className="flex items-start justify-between gap-2">
        <div className="space-y-1">
          {code && <div className="font-semibold opacity-90">{code}</div>}
          <div className="opacity-80">{message}</div>
        </div>
        <button
          type="button"
          onClick={handleCopy}
          className="shrink-0 cursor-pointer rounded p-0.5 opacity-50 transition-opacity hover:opacity-100"
        >
          <Icon icon={copied ? CheckIcon : CopyIcon} size="sm" />
        </button>
      </div>
      {traceParent && (
        <div className="font-mono text-[10px] opacity-50">{traceParent}</div>
      )}
      {details && (
        // Bounded and scrollable: `details` is often a full backend stack
        // trace, and unbounded it made the toast taller than the viewport.
        // The toaster sits top-center, exactly where dialogs render, so an
        // oversized toast covered the dialog it was reporting on.
        <div className="mt-1 max-h-[40vh] overflow-y-auto font-mono text-[10px] leading-tight whitespace-pre-wrap opacity-50">
          {details}
        </div>
      )}
    </div>
  );
}
